import { KeyboardEventHandler, useEffect, useState } from 'react'

import CreatableSelect from 'react-select/creatable';
import { ActionMeta, OnChangeValue, StylesConfig } from 'react-select';

const components = {
    DropdownIndicator: null,
}

interface Option {
    readonly label: string;
    readonly value: string;
    readonly isFixed?: boolean;
}

const createOption = (label: string) => ({
    label,
    value: label,
})

interface State {
    // readonly inputValue: string;
    readonly value: readonly Option[];
}

interface TagsProps {
    onChange: Function;
    isInvalid?: boolean;
    initialValue?: Option[];
}

function Tags({ initialValue = [], isInvalid, onChange }: TagsProps) {

    const [options, setOptions] = useState<Option[]>([])
    const [inputValue, setInputValue] = useState<string>('')

    const styles: StylesConfig<Option, true> = {
        multiValue: (base, state) => {
          return state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base;
        },
        multiValueLabel: (base, state) => {
          return state.data.isFixed
            ? { ...base, fontWeight: 'bold', paddingRight: '14px !important' }
            : base;
        },
        multiValueRemove: (base, state) => {
          return state.data.isFixed ? { ...base, display: 'none' } : base;
        },
    }

    const orderOptions = (values: readonly Option[]) => {
        return values
          .filter((v) => v.isFixed)
          .concat(values.filter((v) => !v.isFixed));
      };

    const handleChange = (
        value: OnChangeValue<Option, true>,
        actionMeta: ActionMeta<Option>
    ) => {
        
        switch (actionMeta.action) {
            case 'remove-value':
            case 'pop-value':
                if (actionMeta.removedValue && actionMeta.removedValue.isFixed) {
                    return;
                }
                break;
            case 'clear':
                value = options.filter((v) => v.isFixed);
                break;
        }
    
        setOptions(orderOptions(value))
        onChange(orderOptions(value).map( v => v.value))
    }

    const handleInputChange = (inputValue: string) => {
        setInputValue(inputValue)
    }

    const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = (event: any) => {

        if (!inputValue) return;

        switch (event.key) {
            case 'Enter':
            case 'Tab':
                const exists = options.find( (option: Option) => option.value === inputValue);
                let newValue = options;
                if(!exists) {
                    newValue = [...options, createOption(inputValue)];
                }

                onChange(newValue.map( v => v.value))

                setOptions(newValue)
                setInputValue('')
                
                event.preventDefault();
        }
    }

    useEffect(() => {
        setOptions(initialValue)
    }, [initialValue])
   
    return (

        <CreatableSelect
            components={components}
            inputValue={inputValue}
            isClearable={false}
            isMulti
            // menuIsOpen={false}
            noOptionsMessage={ () => 'Sin opciones'}
            formatCreateLabel={ (inputValue) => <p>Crear: <strong>{inputValue}</strong></p>}
            onChange={handleChange}
            onInputChange={handleInputChange}
            onKeyDown={handleKeyDown}
            placeholder="Escriba algo y pulse enter."
            value={options}
            className={'react-select-creatable ' + (isInvalid ? 'is-invalid' : '')}
            classNamePrefix="react-select"
            styles={styles}
            defaultValue={initialValue}
        />
    )
}

export default Tags